function Image_form_crop(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);
    
    this.cropParam = {
	    x_position: 0,
	    y_position: 0,
	    height: 0,
	    width: 0
    };

    this.selectors = {
	    ButtonOK: '.js-button-ok',
	    Image: '.js-image',
	    ImagePreview: '.js-image-preview'
    };
    
    this.data = {
	    pluginName: 'plugin-name',
	    scaledWidth: 'scaled-width',
	    scaledHeight: 'scaled-height',
	    width: 'width',
	    height: 'height',
	    originalWidth: 'original-width',
	    imageId: 'image-id',
	    targetField: 'target-field',
	    cropParameter: 'crop-parameter'
    };
    
    this.init = function() {	
	    this.dataPluginName = this.$element.data(this.data.pluginName);
	    this.dataScaledWidth = this.$element.data(this.data.scaledWidth);
	    this.dataScaledHeight = this.$element.data(this.data.scaledHeight);
	    this.dataWidth = this.$element.data(this.data.width);
	    this.dataHeight = this.$element.data(this.data.height);
	    this.dataOriginalWidth = this.$element.data(this.data.originalWidth);
	    this.dataImageId = this.$element.data(this.data.imageId);
	    this.dataTargetField = this.$element.data(this.data.targetField);
	    this.dataCropParameter = this.$element.data(this.data.cropParameter);
	    
	    this.$buttonOK = this.$element.find(this.selectors.ButtonOK);
	    this.$image = this.$element.find(this.selectors.Image);
	    this.$imagePreview = this.$element.find(this.selectors.ImagePreview);
	    this.$targetField = $('#'+this.dataTargetField);
	    
	    this.$buttonOK.on('click', this.$onOKClick.bind(this));
	    
	    this.calculateValues();
	    
	    this.cropPlugin();
    };
    
    this.$onOKClick = function(event) {
	    event.preventDefault();
	    	    
	    this.$targetField.val(this.cropParam.x_position+':'+this.cropParam.y_position+':'+this.cropParam.width+':'+this.cropParam.height);
	    
	    this.popup.remove();
    };
    
    this.cropPlugin = function() {
	    this.$image.Jcrop({
			boxWidth: 400,
			bgColor: 'white',
			setSelect: this.initialSelection,
			minSize: [this.scaledMinWidth, 0],
			aspectRatio: this.aspectRatio,
			bgOpacity: 0.3,
			onSelect: (function(params) {
				this.cropParam = {
					x_position: (params.x/this.dataScaledWidth)*100,
				    y_position: (params.y/this.dataScaledHeight)*100,
				    height: (params.h/this.dataScaledHeight)*100,
				    width: (params.w/this.dataScaledWidth)*100
				};
			
				i4_Ajax.factory().
					set_parameter(
						jQuery.param({
			    			js: this.dataPluginName,
			    			call: 'transform',
			    			filemanager_id: this.dataImageId,
			    			resize_width: 200
			    		}) + '&' + jQuery.param(this.cropParam)
					).
					set_option({
					    on_complete: (function(response) {
							response = JSON.parse(response);
							
					    	if (response.success) {
					    		this.$imagePreview.attr('src', response.src);			    	
					    	}
					    	
					    }).bind(this)
					}).
					run();
			}).bind(this)
		});
    };
    
    this.calculateValues = function() {
	    this.scaledMinWidth = this.dataWidth / this.dataOriginalWidth * this.dataScaledWidth;
	    if (this.scaledMinWidth > this.dataScaledWidth) {
		    this.scaledMinWidth = this.dataScaledWidth;
	    }
	    
	    this.aspectRatio = undefined;
	    if (this.dataHeight != '') {
		    this.aspectRatio = this.dataWidth/this.dataHeight;
	    }
	    
	    if (this.dataCropParameter.length > 0) {
		    this.initialSelection = this.dataCropParameter;
	    } else {
		    this.initialSelection = [
			    0,
			    0,
			    this.dataScaledWidth,
			    this.dataScaledHeight
		    ];
	    }
    };
}
